import React, { useState, useEffect } from "react";
import { useIntl } from "react-intl";

import SelectItem from "../selectItem";
import SelectItemWithLoad from "../selectItemWithLoad";
import { getEntities } from "../../../../modules/crudOperations";

const IncotermItem = ({
  label,
  disabled,
  optional,
  onChange,
  inlineLabel,
  productCode,
  formItemLayout,
  initialServices,
  getFieldDecorator,
}) => {
  const intl = useIntl();
  const [incoterms, setIncoterms] = useState();
  useEffect(() => {
    getEntities("incoterm", (data) =>
      setIncoterms(
        productCode === "ELI" || productCode === "ELD"
          ? data && data.filter((i) => i.enabledForEuroLine)
          : data
      )
    );
  }, [productCode, intl.locale]);

  return (
    <SelectItemWithLoad
      options={incoterms}
      errorMessage={intl.formatMessage({
        id: "consignment.services.incotermsError",
        defaultMessage:
          "Při načítání parity nastala chyba, pokud chcete paritu zadat, opakujte prosím načtení formuláře!",
      })}
    >
      <SelectItem
        toolTip
        allowClear
        useLongCode
        label={label}
        onChange={onChange}
        optional={optional}
        disabled={disabled}
        options={incoterms}
        fieldName="incotermId"
        formItemLayout={formItemLayout}
        labelCol={inlineLabel ? undefined : 2}
        wrapperCol={inlineLabel ? undefined : 15}
        message={intl.formatMessage({
          id: "consignment.services.emptyIncoterms",
          defaultMessage: "Vyberte prosím paritu!",
        })}
        getFieldDecorator={getFieldDecorator}
        initialValue={initialServices && initialServices.incotermId}
      />
    </SelectItemWithLoad>
  );
};

export default IncotermItem;
